<template>
  <div class="main-content">
    <sideBarOrderModal
      v-if="orderModalData.open"
      :modalData="orderModalData"
      :onModalClose="closeOrderModal"
    />
    <EmptyCardModal
      v-if="modalData"
      ref="emptyModal"
      :onModalClose="closeModal"
      :onModalAccept="updatePhoneRecord"
      :modalData="modalData"
    >
      <slot>
        <div>
          <input
            v-model="modalData.comment"
            placeholder="Комментарий к звонку"
            type="text"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <input v-model="modalData.hideRecord" type="checkbox" id="ch_1"/>
          <label class="pointer" for="ch_1">Скрыть звонок</label>
        </div>
        <div v-if="modalData.message" class="alert alert-info">
          {{ modalData.message }}
        </div>
      </slot>
    </EmptyCardModal>

    <div class="card">
      <div class="card-header">
        <h5>Пропущенные звонки и запросы на обратный звонок</h5>
      </div>
      <div class="card-body">
        <pulse-loader
          v-if="loading"
          :loading="loading"
          :color="loadingColor"
          class="text-center"
        />
        <div>
          <div class="text-right p-b-10">
            <button class="btn btn-sm btn-success" @click="getMissedCalls">
              Обновить
            </button>
          </div>
          <table class="table table-hover table-sm">
            <thead>
            <tr>
              <th></th>
              <th>Кто звонил</th>
              <th>Клиент</th>
              <th>Куда звонил</th>
              <th style="min-width: 250px">Прозвоны</th>
              <th>всплывашка</th>
              <th>Комментарий</th>
              <th></th>
            </tr>
            </thead>
            <tbody v-if="!loading">
            <tr v-for="(record, phone, index) in records" :key="index">
              <td>
                <p>{{ index + 1 }}</p>
                {{ record.id }}
              </td>
              <td>
                <template v-if="record.type_id === 3">
                  <p><span class="badge badge-dark">Звонок создан на сайте</span> <span
                    class="badge badge-info">{{ $AllProjects[record.data?.site_id]?.title }}</span></p>
                </template>
                <template v-else>
                  <p>{{ record.phone_title }}</p>
                </template>
                <p class="text-muted created_ago_missed_calls">{{ printDate(record.created_at, 'DD.MM.YYYY HH:mm') }}
                  <span class="badge badge-info p-0">
                    <time-ago refresh :datetime="record.created_at" locale="ru" long/>
                  </span>
                </p>
              </td>
              <td>
                <div v-if="record.client">
                  <p>{{ record.client.name }}</p>
                  <p class="text-muted">
                    зарегистрирован: {{ printDate(record.client.created_at, 'DD.MM.YYYY HH:mm') }}
                  </p>
                  <div v-if="blackList[record.phone_title]">
                    <p>
                      <i class="icon-fa icon-fa-warning color-red"></i>
                      <strong>Черный список</strong>
                    </p>
                    <p class="text-muted">
                      добавлен: {{ printDate(blackList[record.phone_title].created_at, 'DD.MM.YYYY HH:mm') }}
                    </p>
                    <div
                      v-for="comment in blackList[record.phone_title]
                          .comments"
                      :key="comment.created_at"
                    >
                      <p>{{ comment.text }}</p>
                      <p class="text-muted">
                        {{ comment.user_name }} - {{ printDate(comment.created_at, 'DD.MM.YYYY HH:mm') }}
                      </p>
                    </div>
                  </div>
                  <div class="flex flex-wrap" v-if="record.client.orders">
                    <div
                      v-for="order in record.client.orders"
                      :key="order.id"
                      class="order_block"
                    >
                      ({{ $AllProjects[order.site_id].name }})
                      {{ order.id }} ({{
                        ($AllCities[order.city_id] &&
                          $AllCities[order.city_id].short_name) ||
                        "Почтовая"
                      }})
                      <span class="badge badge-success">{{
                          statuses[order.status]
                        }}</span>
                      <button
                        @click="openOrderInModal(order.id)"
                        class="btn btn-xs btn-info newWindowBtn mr-1"
                      >
                        <i class="icon-fa icon-fa-eye"></i>
                      </button>
                      <template v-if="order.status < 0">
                        <i
                          class="comment_tooltip_fa icon-fa icon-fa-info-circle it-has-a-tooltip"
                          v-tooltip="{
                            placement: 'bottom-center',
                            content: order.reject_comment
                          }"
                        ></i>
                      </template>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div>
                  <p>{{ record.destination }}</p>
                  <p class="text-muted">{{ record.ip_phone && record.ip_phone.description }}
                    <div v-if="record.type_id === 3 && record.black_list">
                      <p>
                        <i class="icon-fa icon-fa-warning color-red"></i>
                        <strong>Черный список</strong>
                      </p>
                      <p class="text-muted">
                        добавлен: {{ printDate(record.black_list.created_at, 'DD.MM.YYYY HH:mm') }}
                      </p>
                      <div
                        v-for="comment in record.black_list.comments" :key="comment.created_at">
                        <p>{{ comment.text }}</p>
                        <p class="text-muted">
                          {{ comment.user_name }} - {{ printDate(comment.created_at, 'DD.MM.YYYY HH:mm') }}
                        </p>
                      </div>
                    </div>
                  </p>
                </div>
                <template
                  v-if="record.extra_calls && record.extra_calls.length"
                >
                  <div
                    v-for="(exCall, ind1) in record.extra_calls"
                    :key="ind1"
                  >
                    <p>{{ exCall.destination }}</p>
                    <p class="text-muted">{{ record.ip_phone && record.ip_phone.description }}
                      <!--                      {{-->
                      <!--                        mangoLines[exCall.destination]-->
                      <!--                          ? $AllProjects[-->
                      <!--                            mangoLines[exCall.destination].project_id-->
                      <!--                            ].name +-->
                      <!--                          " (" +-->
                      <!--                          $AllCities[mangoLines[exCall.destination].city_id]-->
                      <!--                            .short_name +-->
                      <!--                          ")"-->
                      <!--                          : "Не определено"-->
                      <!--                      }}-->
                    </p>
                  </div>
                </template>
              </td>
              <td>
                <template v-if="callBack[record.phone_title]">
                  <div
                    v-for="(call, ind) in callBack[record.phone_title]"
                    :key="ind"
                  >
                    <p>
                      ({{ call.user_id }}:{{ call.id }})
                      {{ call.user && call.user.name }}
                    </p>
                    <p>{{ call.phone_title }}</p>
                    <p class="text-muted">{{ printDate(call.created_at, 'DD.MM.YYYY HH:mm') }}</p>
                    <button
                      v-if="!call.showRecord && call.file_link"
                      @click="call.showRecord = true"
                      class="btn btn-success btn-xs"
                      type="button"
                    >
                      Показать запись звонка
                    </button>
                    <div v-if="call.showRecord">
                      <audio controls v-if="call.audio_record_id">
                        <source
                          :src="
                              `https://admin.rancond.info/api/noa/mangoRecord/${call.id}`
                            "
                          type="audio/mpeg"
                        />
                        Your browser does not support the audio tag.
                      </audio>
                    </div>
                  </div>
                </template>
              </td>
              <td>
                <span class="badge badge-dark mr-1"
                      v-for="u in (record?.data?.notified_users ?? [])">{{ u.user_name }} ({{ u.user_id }})</span>
              </td>
              <td>
                <div v-for="(comment, ind) in record.comments" :key="ind">
                  <p>{{ comment.comment }}</p>
                  <p class="text-muted">
                    {{ comment.user_name }} ({{ printDate(comment.created_at, 'DD.MM.YYYY HH:mm', null, 0) }})
                  </p>
                </div>
                <button
                  @click="openCommentModal(record)"
                  class="btn btn-xs btn-info"
                >
                  Редактировать
                </button>
              </td>
              <td>
                <template v-if="record.type_id === 3">
                  <LoadingButton
                    title='<i class="icon-fa icon-fa-phone-square"></i>'
                    type="button"
                    :loading="btnsLoading[record.id]"
                    color="white"
                    :onClick="() => makeBackPhoneCall(record)"
                    className="btn btn-success btn-xs missed_phoneCall_btn"
                  />
                </template>
                <template v-else>
                  <MakePhoneCall
                    :recordId="record.id"
                    :onCall="updateRecords"
                  />
                </template>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import moment from "moment";
import VueLadda from "vue-ladda/src/vue-ladda.vue";
import MakePhoneCall from "../../components/phoneCalls/MakePhoneCall";
import EmptyCardModal from "@/components/modals/EmptyCardModal";
import sideBarOrderModal from "@/components/modals/orders/sideBarOrderModal";
import TimeAgo from "vue2-timeago";
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  title: "Пропущенные вызовы",
  components: {
    LoadingButton,
    TimeAgo,
    VueLadda,
    MakePhoneCall,
    EmptyCardModal,
    sideBarOrderModal
  },
  data() {
    return {
      blackList: {},
      btnsLoading: {},
      loading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      records: {},
      callBack: {},
      mangoLines: {},
      modalData: null,
      orderModalData: {},
      statuses: {
        9999: "ручная",
        0: "c сайта",
        1: "обработана",
        2: "назначена",
        3: "доставлена",
        11: "доставлена",
        "-2": "отказ у менеджера",
        "-3": "отказ у курьера"
      }
    };
  },
  computed: {
    $AllCities() {
      return this.$store.getters["platform/cities"];
    },
    $userPhones() {
      return this.$store.getters["user/phoneNumbers"];
    },
    $AllProjects() {
      const projects = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return projects;
    }
  },
  mounted() {
    this.getMissedCalls();
    // this.Toast.fire({
    //     type: "info",
    //     title: 'sadsad',
    //     timer: 3000,
    //     animation: true,
    //     confirmButtonText: 'btn',
    //     showConfirmButton: true
    //   })
  },
  methods: {
    closeOrderModal() {
      this.orderModalData = {open: false};
    },
    openOrderInModal(orderId) {
      this.orderModalData = {
        orderId: orderId,
        open: true
      };
    },
    updateRecords() {
      this.getMissedCalls();
    },
    openCommentModal(record) {
      this.modalData = {
        header: "Редактировать звонок",
        comment: null,
        hideRecord: false,
        message: null,
        record: record
      };
    },
    closeModal() {
      this.modalData = null;
    },
    async updatePhoneRecord() {
      if (!this.modalData.comment) {
        this.modalData.message = "Введите текст комментария";
        this.$refs.emptyModal.acceptBtnLoading = false;
        return;
      }
      let {data} = await api.post("/telephony/updateRecord", {
        recordId: this.modalData.record.id,
        comment: this.modalData.comment,
        disable: this.modalData.hideRecord
      });
      if (data.success) {
        toastr["success"]("Успешно", "Сохранено!");
        this.getMissedCalls();
        this.closeModal();
      } else {
        this.modalData.message = data.message || "Ошибка сохранения";
        this.$refs.emptyModal.acceptBtnLoading = false;
      }
    },
    async makeBackPhoneCall(record) {
      if (!this.$userPhones) {
        toastr['warning']('Нет номера телефона для совершения звонка', 'Ошибка');
        return;
      }
      // console.log(record, this.$userPhones.phoneNumbers);
      let phoneNum = this.$userPhones.phoneNumbers.find((p) => p?.connected_phone?.site_id === +record.data.site_id && p?.connected_phone?.city_id === 1);
      if (!phoneNum) phoneNum = this.$userPhones.phoneNumbers.find((p) => p?.connected_phone?.site_id === +record.data.site_id && p?.connected_phone?.city_id === 0);
      if (!phoneNum) phoneNum = this.$userPhones.phoneNumbers.find((p) => p?.connected_phone?.site_id === +record.data.site_id);
      if (!phoneNum) {
        toastr['warning']('Нет номера телефона для совершения звонка2', 'Ошибка');
        return;
      }
      const sip = this.$userPhones.sipAccounts.find((s) => s.acc_id === phoneNum.connected_phone.service_id);
      console.log(sip, phoneNum);
      // return;
      this.$set(this.btnsLoading, record.id, true);
      const {data} = await api.post("/telephony/makePhoneCall2", {
        mango_phone_id: phoneNum.phone_id,
        sip: sip.id,
        phone: record.destination,
        mango_call_id: record.id,
        command: record.id,
      });
      if (data.success) {
        toastr['success']('Звонок создан', 'Успешно!');
        this.getMissedCalls(true);
        // this.data.open = false;
      } else {
        toastr['warning'](data.message ?? 'Сервер не ответил', 'Ошибка!');
      }
      this.this.btnsLoading[record.id] = false;
    },
    async getMissedCalls(silent = false) {
      this.loading = !silent;
      let {data} = await api.index("/phoneCalls/getMissedNew");
      if (data.success) {
        Object.keys(data.records).forEach(rNum => {
          const r = data.records[rNum];
          if (!r.client) {
            const client = data.clients.find(
              c => c.full_phone === r.full_phone
            );
            if (client) {
              r.client = client.client;
            }
          }
        });
        this.blackList = data.blackList;
        this.records = data.records;
        Object.keys(data.callBack).forEach(line => {
          if (typeof data.callBack[line] === 'object') {
            data.callBack[line] = Object.values(data.callBack[line]);
          }
          data.callBack[line].forEach(l => (l.showRecord = false));
        });
        this.callBack = data.callBack;
        this.mangoLines = data.mangoLines.reduce((acc, l) => {
          acc[l.line_number] = {...l};
          return acc;
        }, {});
      }
      this.loading = false;
    }
  }
};
</script>

<style>
.created_ago_missed_calls .v-time-ago__text {
  font-size: 10px;
  color: white;
  padding: 0px 6px;
}

.missed_phoneCall_btn i {
  font-size: 20px;
  text-align: center;
}

</style>

<style scoped>
.comment_tooltip_fa {
  font-size: 20px;
  color: #5bbfde;
  cursor: pointer;
}

.order_block {
  border: 1px solid lightgray;
  padding: 3px 5px;
  margin: 2px;
}

audio {
  height: 25px;
}

p {
  margin-bottom: 2px;
}
</style>
